import React from 'react'
import { useTranslation } from 'react-i18next'

import DateFilter from '../../../../components/filter/DateFilter'
import FullPlacesFilterV2 from '../../../../containers/places/filters/FullPlacesFilterV2'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  const { t } = useTranslation('common')

  return (
    <ScreenViewFilterBar screen="place_non_compliances" open={open}>
      <FullPlacesFilterV2 />
      <DateFilter label={t('opening')} field="insertedAt" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
